import buttonStyles from "@/styles/Button.module.scss";
import classnames from "classnames";
import { forwardRef, useCallback, useEffect, useRef } from "react";

const Button = forwardRef((props, ref) => {
  const {
    className,
    fillColor,
    fillMainColor,
    fillGray,
    fillLightGray,
    fillCautionColor,
    fillTransparentGray,
    fillWhiteColor,
    borderBlue,
    borderGray,
    borderLight,
    borderCaution,
    fontFixed,
    fontFixedLineHeight,
    fontBold,
    large,
    medium,
    small,
    largeFont,
    favBtn,
    favBtnWithLabel,
    listRow,
    scale,
    inline,
    transparent,
    loading,
    hoverAnimation,
    bgColor,
    withIcon,
    disabledWithGray,
    borderStyle,
    borderFillColor,
    chatSend,
    chatCloseX,
    chatSelect,
    onClick,
    ..._props
  } = props;

  const processing = useRef(false);
  const timeoutId = useRef();
  const handleClick = useCallback(
    (e) => {
      if (processing.current) {
        e?.preventDefault();
        return;
      } else {
        if (typeof onClick === "function") {
          onClick(e);
        }
        processing.current = true;
        timeoutId.current = setTimeout(() => {
          processing.current = false;
        }, 3000);
      }
    },
    [onClick]
  );

  useEffect(() => {
    return () => {
      processing.current = false;
      clearTimeout(timeoutId.current);
    };
  }, []);

  return (
    <button
      ref={ref}
      className={classnames(buttonStyles.btn, className, {
        [buttonStyles.fillColor]: fillColor,
        [buttonStyles.borderFillColor]: borderFillColor,
        [buttonStyles.fillMainColor]: fillMainColor,
        [buttonStyles.fillGray]: fillGray,
        [buttonStyles.fillLightGray]: fillLightGray,
        [buttonStyles.fillCautionColor]: fillCautionColor,
        [buttonStyles.fillTransparentGray]: fillTransparentGray,
        [buttonStyles.fillWhiteColor]: fillWhiteColor,
        [buttonStyles.borderBlue]: borderBlue,
        [buttonStyles.borderGray]: borderGray,
        [buttonStyles.borderLight]: borderLight,
        [buttonStyles.borderCaution]: borderCaution,
        [buttonStyles.fontFixed]: fontFixed,
        [buttonStyles.fontFixedLineHeight]: fontFixedLineHeight,
        [buttonStyles.fontBold]: fontBold,
        [buttonStyles.large]: large,
        [buttonStyles.medium]: medium,
        [buttonStyles.small]: small,
        [buttonStyles.largeFont]: largeFont,
        [buttonStyles.favBtn]: favBtn && !favBtnWithLabel,
        [buttonStyles.favBtnWithLabel]: favBtn && favBtnWithLabel,
        [buttonStyles.listRow]: listRow,
        [buttonStyles.scale]: scale,
        [buttonStyles.inline]: inline,
        [buttonStyles.transparent]: transparent,
        [buttonStyles.loading]: loading,
        [buttonStyles.hoverAnimation]: hoverAnimation,
        [buttonStyles.bgColor]: bgColor,
        [buttonStyles.withIcon]: withIcon,
        [buttonStyles.disabledWithGray]: disabledWithGray,
        [buttonStyles.borderStyle]: borderStyle,
        [buttonStyles.chatSend]: chatSend,
        [buttonStyles.chatCloseX]: chatCloseX,
        [buttonStyles.chatSelect]: chatSelect,
      })}
      onClick={handleClick}
      {..._props}
    >
      {props.children}
    </button>
  );
});
Button.displayName = "Button";
export default Button;
